import type { NavigationConfig } from '../types'

export const navigationConfig: NavigationConfig = {
  links: [
    { label: 'Home', path: '/' },
    { label: 'Portfolio', path: '/portfolio' },
    { label: 'Services', path: '/services' },
    { label: 'About', path: '/about' },
    { label: 'Blog', path: '/blog' },
    { label: 'Contact', path: '/contact' },
  ],
  cta: { label: 'Get a Quote', path: '/contact' },
}

export const siteMeta = {
  name: 'SST WebAgency',
  tagline: 'We Build Digital Excellence',
  description:
    'Premium web design and development agency crafting high-performance digital experiences with cutting-edge technology.',
  url: 'https://sstwebagency.com',
  logo: '/images/sst-logo.png',
  favicon: '/favicon.svg',
  headingFont: 'Inter',
  bodyFont: 'Inter',
}
